import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { selectMasterCompany } from 'store/auth/selectors';
import { selectAssignedUsers } from 'store/loanApplications/selectors';

import { resolveLoanOfficer } from './utils';

const useOriginatorCompensation = () => {
  const masterCompany = useSelector(selectMasterCompany);
  const assignedUsers = useSelector(selectAssignedUsers);

  return useMemo(
    () => ({
      loanOfficer: resolveLoanOfficer(assignedUsers),
      broker: null,
      creditor: masterCompany?.name ? { name: masterCompany.name, note: 'Lender of record' } : null,
      compensation: null,
    }),
    [assignedUsers, masterCompany],
  );
};

export default useOriginatorCompensation;
